import React, { FC } from 'react';
import { StickyFooter } from '@/StickyFooter';
import ErrorLayout from '../layouts/Error.layout';
import Button from '@/components/Button';

export interface IError500Props {
  code: string;
  title?: string;
  onClick?: () => void;
  className?: string;
}

const Error500: FC<IError500Props> = ({
  title = 'مشکل فنی رخ داده است',
  code,
  className,
  onClick,
}) => (
  <ErrorLayout
    className={className}
    description={<>خطای نوع {code} بوجود آمده، لطفا دوباره تلاش کنید.</>}
    title={title}
    type={500}
  >
    {typeof onClick === 'function' && (
      <StickyFooter>
        <Button
          className="mt-auto"
          variant="outline"
          isFullWidth
          onClick={onClick}
        >
          تلاش مجدد
        </Button>
      </StickyFooter>
    )}
  </ErrorLayout>
);

export default Error500;
